import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke112aRequest, Sgke112aResponse, Sgke112aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke112aService {

  /**
   * コンストラクタ
   * @param {Sgke112aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke112aService
   */
  constructor(
    public service: Sgke112aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * Sgke112aAPI実行
   *
   * @param {Sgke112aRequest} request
   * @return {*}  {Observable<Sgke112aResponse>}
   * @memberof UsedSgke112aService
   */
  public doSgke112a(request: Sgke112aRequest): Observable<Sgke112aResponse> {

    return this.service.sgke112aPost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE112A');
          return throwError(err.message);
        })
      );
  }

}

